// Keeps <html> in sync with the theme preference and, for 'system', with
// live OS changes. Also mirrors the locale onto <html lang>. Mount once at
// the app root.

import { useEffect } from 'react';
import { useSettings } from '../settings/useSettings.js';
import { DARK_QUERY, applyResolvedTheme, resolveTheme, systemPrefersDark } from './theme.js';

export function useApplyTheme(): void {
  const preference = useSettings((s) => s.theme);
  const locale = useSettings((s) => s.locale);

  useEffect(() => {
    const root = document.documentElement;
    applyResolvedTheme(resolveTheme(preference, systemPrefersDark()), root);
    if (preference !== 'system' || typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(DARK_QUERY);
    const onChange = (e: MediaQueryListEvent) =>
      applyResolvedTheme(resolveTheme('system', e.matches), root);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [preference]);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
}
